import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  List,
  Divider,
  Button,
  Badge,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import ApartmentRounded from "@mui/icons-material/ApartmentRounded";
import CalendarMonthRounded from "@mui/icons-material/CalendarMonthRounded";
import CampaignRounded from "@mui/icons-material/CampaignRounded";
import LeaderboardRounded from "@mui/icons-material/LeaderboardRounded";
import AccountBalanceRounded from "@mui/icons-material/AccountBalanceRounded";
import AccountBalanceWalletRounded from "@mui/icons-material/AccountBalanceWalletRounded";
import ChatRounded from "@mui/icons-material/ChatRounded";
import EmailRounded from "@mui/icons-material/EmailRounded";
import LocalPharmacyRounded from "@mui/icons-material/LocalPharmacyRounded";
import LogoutRounded from "@mui/icons-material/LogoutRounded";
import MapRounded from "@mui/icons-material/MapRounded";
import MedicalInformationRounded from "@mui/icons-material/MedicalInformationRounded";
import PeopleRounded from "@mui/icons-material/PeopleRounded";
import PersonSearch from "@mui/icons-material/PersonSearch";
import QuestionAnswerRounded from "@mui/icons-material/QuestionAnswerRounded";
import ScheduleRounded from "@mui/icons-material/ScheduleRounded";
import SettingsRounded from "@mui/icons-material/SettingsRounded";
import SmsRounded from "@mui/icons-material/SmsRounded";
import VerifiedRounded from "@mui/icons-material/VerifiedRounded";
import ForumRounded from "@mui/icons-material/ForumRounded";
import ExitToAppRounded from "@mui/icons-material/ExitToAppRounded";
import SchoolRounded from "@mui/icons-material/SchoolRounded";
import HealthAndSafetyRounded from "@mui/icons-material/HealthAndSafetyRounded";
import MedicationRounded from "@mui/icons-material/MedicationRounded";
import TrendingUpRounded from "@mui/icons-material/TrendingUpRounded";
import BarChartRounded from "@mui/icons-material/BarChartRounded";
import PsychologyRounded from "@mui/icons-material/PsychologyRounded";
import BusinessRounded from "@mui/icons-material/BusinessRounded";
import InsightsRounded from "@mui/icons-material/InsightsRounded";
import ReplayRounded from "@mui/icons-material/ReplayRounded";
import AutoFixHighRounded from "@mui/icons-material/AutoFixHigh";
import AssignmentRounded from "@mui/icons-material/AssignmentRounded";
import NoteAltRounded from "@mui/icons-material/NoteAltRounded";
import HistoryRounded from "@mui/icons-material/HistoryRounded";
import MonitorHeartRounded from "@mui/icons-material/MonitorHeartRounded";
import SupervisorAccountRounded from "@mui/icons-material/SupervisorAccountRounded";
import AccountTreeRounded from "@mui/icons-material/AccountTreeRounded";
import DashboardRounded from "@mui/icons-material/DashboardRounded";
import LocalHospitalRounded from "@mui/icons-material/LocalHospitalRounded";
import EventAvailableRounded from "@mui/icons-material/EventAvailableRounded";
import FactCheckRounded from "@mui/icons-material/FactCheckRounded";
import ReportProblemRounded from "@mui/icons-material/ReportProblemRounded";
import SecurityRounded from "@mui/icons-material/SecurityRounded";
import AssessmentRounded from "@mui/icons-material/AssessmentRounded";
import PublicRounded from "@mui/icons-material/PublicRounded";
import ChecklistRounded from "@mui/icons-material/ChecklistRounded";
import MenuBookRounded from "@mui/icons-material/MenuBookRounded";
import BiotechRounded from "@mui/icons-material/BiotechRounded";
import QrCode2Rounded from "@mui/icons-material/QrCode2Rounded";
import QrCodeScannerRounded from "@mui/icons-material/QrCodeScannerRounded";
import LinkRounded from "@mui/icons-material/LinkRounded";
import RecordVoiceOverRounded from "@mui/icons-material/RecordVoiceOverRounded";
import HomeRounded from "@mui/icons-material/HomeRounded";
import VideoLibraryRounded from "@mui/icons-material/VideoLibraryRounded";
import PaletteRounded from "@mui/icons-material/PaletteRounded";
import ShareRounded from "@mui/icons-material/ShareRounded";
import HowToRegRounded from "@mui/icons-material/HowToRegRounded";
import NavListItem from "components/common/NavListItem";
import NavListGroup from "components/common/NavListGroup";
import { ChatContext } from "context/Chat";
import { useChat } from "components/chatbot/ContextBox/useChat";
import { useAuth } from "hooks/useAuth";
import { useOrgAdminAccess } from "hooks/useOrgAdminAccess";
import { usePendingEhrMedRecCount } from "hooks/usePendingEhrMedRecCount";
import { getTrialLengthForRole } from "constants/trials";
import {
  MASTERCHART_DRAWER_MATCH_PATHS,
  masterChartPath,
} from "constants/masterChartRoutes";
import { displayPath } from "features/decisionPoint/marketing/fusionMsiMarketingRouting";

const ADVERTISING_MATCH_PATHS = [
  "/dashboard/advertising",
  "/dashboard/advertising/slots",
  "/dashboard/advertising/balance",
  "/dashboard/advertising/performance",
];

const AdvertiseNavGroup = ({ includeZipSlotAds = true }) => {
  if (!includeZipSlotAds) return null;
  return (
  <NavListGroup
    icon={<CampaignRounded />}
    text="Advertise"
    secondary="Zip slots, balance & performance"
    matchPaths={ADVERTISING_MATCH_PATHS}
  >
    <NavListItem
      icon={<LeaderboardRounded />}
      text="Zip slots"
      secondary="7 ranked CPC slots"
      link="/dashboard/advertising/slots"
    />
    <NavListItem
      icon={<AccountBalanceWalletRounded />}
      text="Ad balance"
      secondary="Top-up & auto-recharge"
      link="/dashboard/advertising/balance"
    />
    <NavListItem
      icon={<AssessmentRounded />}
      text="Ad performance"
      secondary="Clicks, spend & rank"
      link="/dashboard/advertising/performance"
    />
  </NavListGroup>
  );
};

export const OnboardingDrawer = ({ logout, hideCareMap = false }) => (
  <List>
    {!hideCareMap && (
      <NavListItem icon={<MapRounded />} text="CareMap" link="/" />
    )}
    <NavListItem icon={<LogoutRounded />} text="Log Out" onClick={logout} />
  </List>
);

export const MasterChartDrawer = () => (
  <>
    <List>
      <NavListGroup
        icon={<HealthAndSafetyRounded />}
        text="MasterChart"
        secondary="Your personal health record"
        matchPaths={MASTERCHART_DRAWER_MATCH_PATHS}
      >
        <NavListItem
          icon={<FactCheckRounded />}
          text="View record"
          link={masterChartPath()}
        />
        <NavListItem
          icon={<MedicationRounded />}
          text="My Medications"
          link="/dashboard/medications"
        />
        <NavListItem
          icon={<QrCode2Rounded />}
          text="Share with provider"
          link={masterChartPath("share")}
        />
      </NavListGroup>
    </List>
    <Divider />
  </>
);

export const PatientDrawer = ({ subscription, userData }) => {
  const navigate = useNavigate();
  const { newThread } = useContext(ChatContext);
  const { messages } = useChat();
  const { canStartTrial, hasActiveTrial, hasActiveDailyPass } = useAuth();
  const pendingEhrMedRecCount = usePendingEhrMedRecCount();
  const disabled = !messages || messages?.length < 1;
  const [showNoEmail, setShowNoEmail] = useState(false);
  const trialLengthDays = getTrialLengthForRole(userData?.role);

  // [BETA-KIJABE] Temporary flag for Kijabe beta testers — remove when beta period ends.
  // To activate: set `betaAccess: true` on the user's Firestore doc.
  const isBetaKijabe = Boolean(userData?.betaAccess);

  // [BETA-VOXPONT2] Gates the VoxPont2 live-translation beta for patients.
  // Dedicated flag (NOT betaAccess) so the Kijabe cohort isn't opted in by default.
  // To activate: set `voxPontBeta: true` on the user's Firestore doc.
  const isVoxPontBeta = Boolean(userData?.voxPontBeta);

  const handleClose = () => setShowNoEmail(false);

  const copyChat = async () => {
    try {
      const messagesArray = messages.map(
        (message) =>
          `${message.sender === "user" ? "You" : "FusionMSI"}:\n${message.message
          }`
      );
      await navigator.clipboard.writeText(messagesArray.join("\n\n"));
      console.log("Content copied to clipboard");
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const sendEmail = () => {
    if (disabled) return;

    const messagesArray = messages.map(
      (message) =>
        `${message.sender === "user" ? "You" : "FusionMSI"}:\n${message.message
        }`
    );

    window.open(
      "mailto:?subject=FusionMSI Medical SuperIntelligence Transcript&body=" +
      encodeURIComponent(messagesArray.join("\n\n"))
    );

    let t = setTimeout(() => setShowNoEmail(true), 500);
    window.addEventListener("blur", () => clearTimeout(t));
  };

  const navigateNewThread = () => {
    if (disabled) return;
    navigate("/dashboard");
    newThread();
  };

  return (
    <>
      <EmailDialog open={showNoEmail} onClose={handleClose} onCopy={copyChat} />
      <List>
        <NavListItem
          icon={<HomeRounded />}
          text="Home"
          secondary="Your health records, check-in, and tools"
          link="/dashboard/home"
        />
        <NavListItem
          icon={<SchoolRounded />}
          text="Medical Library"
          secondary="General medical education"
          link="/dashboard/medical-library"
        />
      </List>
      <Divider />
      <List>
        <NavListGroup
          icon={<HealthAndSafetyRounded />}
          text="MasterChart"
          secondary="Your personal health record"
          matchPaths={MASTERCHART_DRAWER_MATCH_PATHS}
        >
          <NavListItem
            icon={<FactCheckRounded />}
            text="View record"
            link={masterChartPath()}
          />
          <NavListItem
            icon={<MedicationRounded />}
            text="My Medications"
            link="/dashboard/medications"
          />
          <NavListItem
            icon={
              <Badge
                badgeContent={pendingEhrMedRecCount}
                color="error"
                invisible={!pendingEhrMedRecCount}
              >
                <LinkRounded />
              </Badge>
            }
            text="Linked Providers"
            link="/dashboard/linked-providers"
          />
          {/* TODO: add "Medication Tracking" here once re-enabled (post Twilio BAA). */}
          <NavListItem
            icon={<QrCode2Rounded />}
            text="Share with provider"
            link={masterChartPath("share")}
          />
          <NavListItem
            icon={<QrCodeScannerRounded />}
            text="Scan VisitStart QR"
            secondary="Open a clinic visit from a QR code"
            link="/visit-start?scan=1"
          />
        </NavListGroup>
        <NavListItem
          icon={<EmailRounded />}
          text="Messages"
          secondary="Care messages from your team"
          link="/dashboard/messages"
        />
        <NavListItem
          icon={<AssignmentRounded />}
          text="Discharge Instructions"
          secondary="Summaries from your facility visits"
          link="/dashboard/discharge-instructions"
        />
        {/* [BETA-VOXPONT2] Live-translation voice session — shown only to flagged patients */}
        {isVoxPontBeta && (
          <NavListItem
            icon={<RecordVoiceOverRounded />}
            text="VoxPont"
            secondary="Live voice translation (beta)"
            link="/voxpont2"
          />
        )}
        {/* TODO: Medication Tracking disabled until Twilio BAA is in place */}
        {/* <NavListItem
          icon={<TrendingUpRounded />}
          text="Medication Tracking"
          link="/dashboard/medication-tracking"
        /> */}

        {/* [BETA-KIJABE] Upgrade/trial prompt hidden for Kijabe beta users — remove condition when beta ends */}
        {!isBetaKijabe && !subscription && !hasActiveTrial && !hasActiveDailyPass && (
          <NavListItem
            icon={<PersonSearch />}
            text={
              canStartTrial ? "Start Free Trial" : "Upgrade to Commercial Free"
            }
            secondary={
              canStartTrial
                ? `Get full access for ${trialLengthDays} days`
                : undefined
            }
            noSelect
            link="/dashboard/upgrade"
            sx={
              canStartTrial
                ? {
                  "& .MuiListItemText-primary": {
                    color: "primary.main",
                    fontWeight: "medium",
                  },
                  "& .MuiListItemIcon-root": {
                    color: "primary.main",
                  },
                }
                : undefined
            }
          />
        )}
      </List>
      <Divider />
    </>
  );
};

export const ProfessionalDrawer = ({
  subscription,
  userData,
  includeZipSlotAds = false,
}) => {
  const { canStartTrial, hasActiveTrial, hasActiveDailyPass } = useAuth();
  const trialLengthDays = getTrialLengthForRole(userData?.role);

  // [BETA-KIJABE] Temporary flag for Kijabe beta testers — remove when beta period ends.
  // To activate: set `betaAccess: true` on the user's Firestore doc.
  const isBetaKijabe = Boolean(userData?.betaAccess);

  return (
    <>
      {/* [BETA-KIJABE] Shown only for Kijabe beta users */}
      {isBetaKijabe && (
        <>
          <List>
            <NavListItem
              icon={<QuestionAnswerRounded />}
              text="Ask Me Anything"
              secondary="Medical Q&A"
              link="/dashboard/ask-me-anything"
            />
          </List>
          <Divider />
        </>
      )}
      <List>
        {/*
          ChartMind link — navigates back to the live encounter (preserved across navigation
          by ChartMindSessionProvider). To start fresh, the page itself exposes a "New
          Encounter" button.
        */}
        <NavListItem
          icon={<NoteAltRounded />}
          text="ChartMind"
          secondary="Patient encounters made easy"
          link="/dashboard/chartmind"
        />
        <NavListItem
          icon={<MonitorHeartRounded />}
          text="DecisionPoint"
          secondary="Clinical co-pilot at the bedside"
          link={displayPath()}
        />
        <NavListItem
          icon={<ForumRounded />}
          text="PeerView Case Consultation"
          secondary="Ask about your encounter"
          link="/dashboard/peerview"
        />
        <NavListItem
          icon={<LocalPharmacyRounded />}
          text="Drug Reference"
          secondary="Emergency medicine drug cards"
          link="/dashboard/drug-reference"
        />
        {/* [BETA-KIJABE] Hidden for Kijabe beta users (no session persistence) */}
        {!isBetaKijabe && (
          <NavListItem
            icon={<HistoryRounded />}
            text="My Charts"
            secondary="View saved encounters"
            link="/dashboard/chartmind/sessions"
          />
        )}
      </List>
      {includeZipSlotAds ? (
        <>
          <Divider />
          <List>
            <AdvertiseNavGroup includeZipSlotAds />
          </List>
        </>
      ) : null}
      <Divider />
      {/* [BETA-KIJABE] Upgrade/trial prompt hidden for Kijabe beta users — remove condition when beta ends */}
      {!isBetaKijabe && !subscription && !hasActiveTrial && !hasActiveDailyPass && (
        <>
          <List>
            <NavListItem
              icon={<PersonSearch />}
              text={
                canStartTrial
                  ? "Start Free Trial"
                  : "Upgrade to Commercial Free"
              }
              secondary={
                canStartTrial
                  ? `Get full access for ${trialLengthDays} days`
                  : undefined
              }
              noSelect
              link="/dashboard/upgrade"
              sx={
                canStartTrial
                  ? {
                    "& .MuiListItemText-primary": {
                      color: "primary.main",
                      fontWeight: "medium",
                    },
                    "& .MuiListItemIcon-root": {
                      color: "primary.main",
                    },
                  }
                  : undefined
              }
            />
          </List>
          <Divider />
        </>
      )}
    </>
  );
};

export const SettingsDrawer = ({ activeSubscriptionRole, userData }) => (
  <>
    <List>
      <NavListItem
        icon={<SettingsRounded />}
        text="Settings"
        link="/dashboard/settings"
      />
    </List>
    <Divider />
  </>
);

export const AdminDrawer = ({ isGlobalAdmin }) => (
  <>
    {isGlobalAdmin && (
      <>
        <List>
          <NavListItem
            icon={<PsychologyRounded />}
            text="Prompts"
            link="/dashboard/prompts"
          />
          <NavListItem
            icon={<VerifiedRounded />}
            text="Location Approval"
            link="/dashboard/admin/approval"
          />
          {/* Assistant Manager hidden from nav (legacy OpenAI-assistant system); page/route still exists.
              <NavListItem
                icon={<SmartToyRounded />}
                text="Assistant Manager"
                link="/dashboard/admin/assistants"
              /> */}
          <NavListItem
            icon={<BarChartRounded />}
            text="Usage Monitor"
            link="/dashboard/admin/usage"
          />
        </List>
        <Divider />
      </>
    )}
  </>
);

/** Platform super-admin: JWT admin claim only (see isGlobalAdmin). Regional admins UI is exclusive to this drawer. */
export const GlobalAdminDrawer = ({ onLogout, hideCareMap = false }) => {
  return (
    <>
      <List>
        <NavListItem
          icon={<PsychologyRounded />}
          text="Prompts"
          link="/dashboard/prompts"
        />
        <NavListItem
          icon={<VerifiedRounded />}
          text="Location Approval"
          link="/dashboard/admin/approval"
        />
        <NavListItem
          icon={<PeopleRounded />}
          text="Regional admins"
          link="/dashboard/admin/regional-admins"
        />
        <NavListItem
          icon={<BusinessRounded />}
          text="Organizations"
          secondary="Provision & partner tiers"
          link="/dashboard/admin/organizations"
        />
        <NavListItem
          icon={<SupervisorAccountRounded />}
          text="Global TCI Managers"
          link="/dashboard/admin/global-tci-managers"
        />
        <NavListItem
          icon={<PublicRounded />}
          text="Global TCI catalog"
          link="/dashboard/global-tci-manager"
        />
        <NavListItem
          icon={<FactCheckRounded />}
          text="HIPAA Compliance"
          link="/dashboard/admin/hipaa-compliance"
        />
        <NavListItem
          icon={<ReportProblemRounded />}
          text="Misdirection triage"
          secondary="CareVerify coverage reports"
          link="/dashboard/careverify/misdirection-triage"
        />
        {/* Assistant Manager hidden from nav (legacy OpenAI-assistant system); page/route still exists.
            <NavListItem
              icon={<SmartToyRounded />}
              text="Assistant Manager"
              link="/dashboard/admin/assistants"
            /> */}
        <NavListItem
          icon={<BarChartRounded />}
          text="Usage Monitor"
          link="/dashboard/admin/usage"
        />
        <NavListItem
          icon={<TrendingUpRounded />}
          text="Network readiness"
          link="/dashboard/admin/readiness"
        />
        <NavListItem
          icon={<MenuBookRounded />}
          text="SpecialtyKB Editors"
          secondary="Review specialty knowledge base"
          link="/specialty-kb/editors"
        />
        <NavListItem
          icon={<BiotechRounded />}
          text="SpecialtyKB DDx"
          secondary="Differential diagnosis from approved KB"
          link="/specialty-kb/ddx"
        />
      </List>
      <Divider />
      <List>
        <NavListItem
          icon={<SettingsRounded />}
          text="Settings"
          link="/dashboard/settings"
        />
        {!hideCareMap && (
          <NavListItem icon={<MapRounded />} text="CareMap" link="/" />
        )}
      </List>
      <Divider />
      <List>
        <NavListItem
          icon={<LogoutRounded />}
          text="Log Out"
          onClick={onLogout}
        />
      </List>
    </>
  );
};

export const RegionalAdminDrawer = ({ onLogout, hideCareMap = false }) => (
  <>
    <List>
      <NavListItem
        icon={<PsychologyRounded />}
        text="Prompts"
        link="/dashboard/prompts"
      />
      <NavListItem
        icon={<TrendingUpRounded />}
        text="Network readiness"
        link="/dashboard/admin/readiness"
      />
    </List>
    <Divider />
    <List>
      <NavListItem
        icon={<SettingsRounded />}
        text="Settings"
        link="/dashboard/settings"
      />
      {!hideCareMap && (
        <NavListItem icon={<MapRounded />} text="CareMap" link="/" />
      )}
    </List>
    <Divider />
    <List>
      <NavListItem
        icon={<LogoutRounded />}
        text="Log Out"
        onClick={onLogout}
      />
    </List>
  </>
);

// [BETA-KIJABE-ADMIN] isBetaAdmin hides Usage (no token tracking for beta orgs).
export const TciManagerDrawer = ({ onLogout, hideCareMap = false }) => (
  <>
    <List>
      <NavListItem
        icon={<DashboardRounded />}
        text="Overview"
        secondary="Team & candidate review"
        link="/dashboard/tci-manager"
      />
      <NavListItem
        icon={<AccountTreeRounded />}
        text="Manage TCIs"
        secondary="Prompt structure"
        link="/dashboard/tci-manager/tcis"
      />
    </List>
    <Divider />
    <List>
      <NavListItem
        icon={<SettingsRounded />}
        text="Settings"
        link="/dashboard/settings"
      />
      {!hideCareMap && (
        <NavListItem icon={<MapRounded />} text="CareMap" link="/" />
      )}
    </List>
    <Divider />
    <List>
      <NavListItem icon={<LogoutRounded />} text="Log Out" onClick={onLogout} />
    </List>
  </>
);

export const ChartMindManagerDrawer = ({
  isBetaAdmin = false,
  showTciManager = false,
  showGlobalTciManager = false,
  showFoundingPartnerAccounting = false,
}) => {
  // Same gate as /asi/roles (useOrgAdminAccess). Do not widen that guard.
  const { canAccess: canAssignAsiRoles } = useOrgAdminAccess();
  return (
  <>
    <List>
      {showGlobalTciManager && (
        <NavListItem
          icon={<PublicRounded />}
          text="Global TCI catalog"
          link="/dashboard/global-tci-manager"
        />
      )}
      {showTciManager && (
        <>
          <NavListItem
            icon={<DashboardRounded />}
            text="Overview"
            secondary="TCI Manager dashboard"
            link="/dashboard/tci-manager"
          />
          <NavListItem
            icon={<AccountTreeRounded />}
            text="Manage TCIs"
            secondary="Prompt structure"
            link="/dashboard/tci-manager/tcis"
          />
        </>
      )}
      <NavListItem
        icon={<ChecklistRounded />}
        text="TCI setup"
        secondary="Happy-path checklist for the governance loop"
        link="/dashboard/tci-setup"
      />
      <NavListItem
        icon={<SchoolRounded />}
        text="Institution Leader orientation"
        secondary="Optional leadership training"
        link="/dashboard/onboarding/institution-leader"
      />
      <NavListItem
        icon={<PsychologyRounded />}
        text="Prompts"
        secondary="Manage AI prompts"
        link="/dashboard/prompts"
      />
      {showFoundingPartnerAccounting && (
        <NavListItem
          icon={<AccountBalanceRounded />}
          text="Partner accounting"
          secondary="Balances and ledger entries"
          link="/dashboard/fusion-founder/accounting"
        />
      )}
      <NavListItem
        icon={<BusinessRounded />}
        text="Team"
        secondary="Manage your team"
        link="/dashboard/team"
      />
      {!isBetaAdmin && (
        <NavListItem
          icon={<BarChartRounded />}
          text="Usage"
          secondary="Monitor token usage"
          link="/dashboard/usage"
        />
      )}
      <NavListItem
        icon={<InsightsRounded />}
        text="Analytics"
        secondary="Usage overview"
        link="/dashboard/analytics"
      />
      <NavListItem
        icon={<TrendingUpRounded />}
        text="Loop analytics"
        secondary="Improvement activity"
        link="/dashboard/loop-analytics"
      />
      <NavListItem
        icon={<FactCheckRounded />}
        text="Readiness"
        secondary="TCI activation & loop health"
        link="/dashboard/readiness"
      />
      <NavListItem
        icon={<SecurityRounded />}
        text="PHI audit log"
        secondary="HIPAA access accounting"
        link="/dashboard/audit"
      />
      <NavListItem
        icon={<AssessmentRounded />}
        text="Institution reports"
        secondary="Monthly loop metrics"
        link="/dashboard/reports"
      />
      <NavListItem
        icon={<VideoLibraryRounded />}
        text="Video Library"
        secondary="Champion rollout videos"
        link="/dashboard/institution-rollout"
      />
      <NavListItem
        icon={<PaletteRounded />}
        text="Customize & Brand"
        secondary="Logo and institution branding"
        link="/dashboard/institution-rollout/brand"
      />
      <NavListItem
        icon={<ShareRounded />}
        text="Distribute"
        secondary="Shareable links per video"
        link="/dashboard/institution-rollout/distribute"
      />
      <NavListItem
        icon={<ReplayRounded />}
        text="Sessions"
        secondary="Review conversation transcripts"
        link="/dashboard/sessions"
      />
      <NavListItem
        icon={<AutoFixHighRounded />}
        text="Prompt candidates"
        secondary="Teacher refinement queue"
        link="/dashboard/prompts/candidates"
      />
      <NavListItem
        icon={<PeopleRounded />}
        text="Role roster"
        secondary="Assign clinical governance roles"
        link="/dashboard/fde-roster"
      />
      {canAssignAsiRoles ? (
        <NavListItem
          icon={<HowToRegRounded />}
          text="ASI Role Assignment"
          secondary="Assign ASI roles"
          link="/asi/roles"
        />
      ) : null}
      <NavListItem
        icon={<MapRounded />}
        text="Clinic locations"
        secondary="Map CareMap clinics to hierarchy nodes"
        link="/dashboard/location-hierarchy"
      />
      <NavListItem
        icon={<MedicalInformationRounded />}
        text="Clinical domains"
        secondary="TCI groupings & managers"
        link="/dashboard/domains"
      />
      <NavListItem
        icon={<AssignmentRounded />}
        text="TCI governance"
        secondary="Interrogatory & clinical standards"
        link="/dashboard/tci-governance/new"
      />
      <AdvertiseNavGroup includeZipSlotAds />
    </List>
    <Divider />
  </>
  );
};

export const FacilityDrawer = ({ userData, includeZipSlotAds = false }) => (
  <>
    <List>
      <NavListItem
        icon={<ScheduleRounded />}
        text="Facility Status Board"
        link="/dashboard"
      />
      <NavListItem
        icon={<CalendarMonthRounded />}
        text="Schedule"
        link="/dashboard/schedule"
      />
      <NavListItem
        icon={<EventAvailableRounded />}
        text="CareVerify availability"
        secondary="Appointment slots & walk-in windows"
        link="/dashboard/careverify/availability"
      />
      <NavListItem
        icon={<VerifiedRounded />}
        text="CareVerify attestation"
        secondary="Payer product-line checklist"
        link="/dashboard/careverify/attestation"
      />
      <NavListItem
        icon={<ForumRounded />}
        text="Patient Messages"
        link="/dashboard/messaging"
      />
      <NavListItem
        icon={<ApartmentRounded />}
        text="Departments"
        link="/dashboard/departments"
      />
      <NavListItem
        icon={<LocalHospitalRounded />}
        text="SAVOIR CARE"
        secondary="ED patient flow board"
        link="/dashboard/savoircare"
      />
      <NavListItem
        icon={<HealthAndSafetyRounded />}
        text="CareStart Studio"
        secondary="Variants & prompt overrides"
        link="/dashboard/carestart-studio"
      />
      {/* TODO: Virtual Queue + Virtual Registration disabled until Twilio BAA is in place */}
      {/* <NavListItem
        icon={<PeopleRounded />}
        text="Virtual Queue"
        link="/dashboard/queue"
      />
      <NavListItem
        icon={<SmsRounded />}
        text="Virtual Registration"
        link="/dashboard/virtual-registration"
      /> */}
      <AdvertiseNavGroup includeZipSlotAds={includeZipSlotAds} />
    </List>
    <Divider />
  </>
);

export const MarketingExecutiveDrawer = () => (
  <>
    <List>
      <AdvertiseNavGroup includeZipSlotAds />
    </List>
    <Divider />
  </>
);

export const BtybMarketerDrawer = () => (
  <>
    <List>
      <NavListItem
        icon={<CampaignRounded />}
        text="City sponsorship"
        secondary="Brought to you by"
        link="/dashboard/btyb"
      />
      <NavListItem
        icon={<MapRounded />}
        text="Caremap2"
        secondary="Preview the banner"
        link="/caremap2"
      />
    </List>
    <Divider />
  </>
);

/** Platform Global TCI Manager without full platform admin authority. */
export const GlobalTciManagerDrawer = ({ onLogout, hideCareMap = false }) => (
  <>
    <List>
      <NavListItem
        icon={<PublicRounded />}
        text="Global TCI catalog"
        link="/dashboard/global-tci-manager"
      />
    </List>
    <Divider />
    <List>
      <NavListItem
        icon={<SettingsRounded />}
        text="Settings"
        link="/dashboard/settings"
      />
      {!hideCareMap && (
        <NavListItem icon={<MapRounded />} text="CareMap" link="/" />
      )}
    </List>
    <Divider />
    <List>
      <NavListItem
        icon={<LogoutRounded />}
        text="Log Out"
        onClick={onLogout}
      />
    </List>
  </>
);

const EmailDialog = ({ open, onClose, onCopy }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>We weren't able to open your email client.</DialogTitle>
    <DialogContent>
      <DialogContentText>
        It looks like you don't have a default email client selected. If you'd
        like to send your chat transcript by email, please copy it to your
        clipboard using the button below.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button variant="contained" onClick={onCopy}>
        Copy Chat Transcript
      </Button>
      <Button onClick={onClose} autoFocus>
        Close
      </Button>
    </DialogActions>
  </Dialog>
);
